var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.95 32.53v62.9a6.6 6.6 0 0 0 3.43 5.78 6.45 6.45 0 0 0 6.66-.29l45.36-30.5a7.72 7.72 0 0 0 0-12.76L45.04 27.1a6.43 6.43 0 0 0-6.65-.33 6.58 6.58 0 0 0-3.44 5.76"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;